module.exports = __webpack_public_path__ + "img/accessory_shoe_01.f5238bbf.svg";